import script from "./MiniVoiceMemoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniVoiceMemoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./MiniVoiceMemoPlayer.vue?vue&type=style&index=0&id=e5091478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5091478"]])

export default __exports__